module.exports = "<h1>{{'applySuccesfullyCreated'|i18n}}</h1>\n<div class=\"text-align-justify\"><p>{{'registrationDoneTextpart1' | i18n}}{{publication.estimatedPrintDeliveryDate| date: 'dd.MM.yyyy'}}{{'registrationDoneTextpart2' | i18n}}</p></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/step-registration-done/step-registration-done.component.html
// module id = ./src/app/+app-custom/components/publication-registration/step-registration-done/step-registration-done.component.html
// module chunks = main